import PropTypes from 'prop-types';
import React from 'react';
import ArrowPagination from '../../../Elements/ArrowPagination/ArrowPagination';
import {
    memberResultsProptype,
    requestUserResultsProptype,
} from '../../../Includes/GroupPropsShape';

import './Paginations.scss';

export default class Paginations extends React.PureComponent {
    static propTypes = {
        /**
         * The current menu item that user has selected
         */
        selectedMenuItem: PropTypes.string.isRequired,
        /**
         * data of group members regarding paginations and member list
         */
        memberResults: memberResultsProptype,
        /**
         * data of requesting to join user regarding paginations and member list
         */
        requestUserResults: requestUserResultsProptype,
        /**
         * function for prev page, nullable
         */
        goToPrevPage: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
        /**
         * function for next page, nullable
         */
        goToNextPage: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
    };

    static defaultProps = {
        selectedMenuItem: '',
        memberResults: {
            page: 1,
            startNum: 0,
            endNum: 0,
            total: 0,
        },
        requestUserResults: {
            page: 1,
            startNum: 0,
            endNum: 0,
            total: 0,
        },
        goToPrevPage: null,
        goToNextPage: null,
    };

    render() {
        const {
            selectedMenuItem,
            memberResults,
            requestUserResults,
            goToPrevPage,
            goToNextPage,
        } = this.props;
        switch (selectedMenuItem) {
            case 'Members':
                return (
                    <div className="component-Groups-ManageMembers-Paginations member">
                        <ArrowPagination
                            numberRange={`${memberResults.startNum} - ${memberResults.endNum}`}
                            total={memberResults.total}
                            prevPage={goToPrevPage}
                            nextPage={goToNextPage}
                            hideArrowIfNoPagination={true}
                        />
                    </div>
                );
            case 'Requests':
                return (
                    <div className="component-Groups-ManageMembers-Paginations request">
                        <ArrowPagination
                            numberRange={`${requestUserResults.startNum} - ${requestUserResults.endNum}`}
                            total={requestUserResults.total}
                            prevPage={goToPrevPage}
                            nextPage={goToNextPage}
                            hideArrowIfNoPagination={true}
                        />
                    </div>
                );
            default:
                return (
                    <div className="component-Groups-ManageMembers-Paginations default">
                        <ArrowPagination
                            numberRange={`0 - 0`}
                            total={0}
                            prevPage={null}
                            nextPage={null}
                            hideArrowIfNoPagination={true}
                        />
                    </div>
                );
        }
    }
}
